import { render, staticRenderFns } from "./MenuType.vue?vue&type=template&id=2a00cb75&scoped=true&"
import script from "./MenuType.vue?vue&type=script&lang=js&"
export * from "./MenuType.vue?vue&type=script&lang=js&"
import style0 from "./MenuType.vue?vue&type=style&index=0&id=2a00cb75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a00cb75",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
installComponents(component, {VBottomSheet,VBtn,VFlex,VIcon,VLayout,VSheet})
